// based on rc-progress 2.5.2
import Progress, { Line, Circle } from './src/';

export { Line, Circle };

export default Progress;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-progress/index.js
// module id = 837
// module chunks = 0